import { render, staticRenderFns } from "./CartComp.vue?vue&type=template&id=f6596f56"
import script from "./CartComp.vue?vue&type=script&lang=js"
export * from "./CartComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports